import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function KpiCard({ title, value, delta, invert = false, hint, testId }) {
  const hasDelta = delta !== undefined && delta !== null && delta !== 0;
  const good = invert ? delta < 0 : delta > 0;
  const deltaColor = !hasDelta ? "text-zinc-500" : good ? "text-lime-400" : "text-rose-400";
  const DeltaIcon = delta > 0 ? TrendingUp : TrendingDown;

  return (
    <div
      data-testid={testId}
      className="bg-[#14181B] border border-[#242B30] rounded-xl p-4 sm:p-5 transition-all duration-200 hover:border-[#323D44] group"
    >
      <div className="flex items-start justify-between gap-2">
        <span className="text-[10px] sm:text-[11px] font-semibold tracking-[0.12em] uppercase text-zinc-500 font-mono leading-tight">
          {title}
        </span>
        {hasDelta && (
          <span className={`flex items-center gap-1 text-[11px] sm:text-xs font-mono font-medium shrink-0 ${deltaColor}`}>
            <DeltaIcon className="h-3 w-3" />
            {Math.abs(delta).toFixed(1)}%
          </span>
        )}
      </div>
      <div className="mt-2.5 text-xl sm:text-2xl lg:text-3xl font-extrabold tracking-tight text-white font-mono break-words">
        {value}
      </div>
      {hint && <div className="mt-1 text-[10px] sm:text-[11px] text-zinc-600 font-mono">{hint}</div>}
    </div>
  );
}
